<template>
  <div
    class="header"
    :class="isWhite?'is-white':''"
  >
    <el-header>
      <div class="title">
        <img :src="img" />
        <span>{{title}}</span>
        <span
          class="secondary-title"
          v-if="secondaryTitle"
        >{{secondaryTitle}}</span>
      </div>
      <div class="right">
        <slot name="right">
          <slot name="right-footer"></slot>
          <slot name="rightUser">
            <div class="userInfo">
              <el-dropdown
                placement="bottom-end"
                trigger="click"
              >
                <span class="el-dropdown-link">
                  {{ userName }}
                  <svg-icon icon-class="down_full_color"></svg-icon>

                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  class="navbar-user-dropdown"
                >
                  <el-dropdown-item
                    v-if="hasChangePwd"
                    @click.native="changePwd"
                  >修改密码</el-dropdown-item>
                  <el-dropdown-item @click.native="userLogOut">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </slot>
        </slot>
      </div>
      <change-password
        @change="changePassword"
        :visible.sync="passwordVisible"
      ></change-password>
    </el-header>
  </div>

</template>

<script>
import auth from "../../scripts/auth";
import ChangePassword from "../../views/ChangePassword.vue";
import utils from "../../scripts/utils";
import { showLoading, hideLoading } from "../../scripts/loading";
import request from "../../scripts/request";
import TextTooltip from "../TextTooltip";
import { refreshToken } from "../../scripts/refreshToken";
import { mapGetters } from "vuex";
import SvgIcon from "../SvgIcon";

export default {
  name: "NavBar",
  components: {
    ChangePassword,
    TextTooltip,
    SvgIcon,
  },
  props: {
    showBreadcrumb: {
      //是否显示面包屑标题
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    secondaryTitle: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default: require("../../assets/images/logo_white.svg"),
    },
    isWhite: {
      //是否为白色背景
      type: Boolean,
      default: false,
    },
    hasChangePwd: {
      //是否有修改密码功能
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      utils,
      menuRoute: [],
      passwordVisible: false,
      menuProp: {
        path: "routeAddress",
        icon: "icon",
        name: "name",
        children: "childList",
      },
      projectRoute: [],
      userVisible: false,
      saveLoading: false,
      choosedStation: "",
      userName: "",
    };
  },
  watch: {
    $route(to) {},
  },
  computed: {
    ...mapGetters(["menuList"]),
  },
  mounted() {},
  created() {
    this.userName = auth.getUserInfo().username;
    // this.projectRoute = this.$router.options.routes;
  },
  methods: {
    /**修改密码-弹窗打开 */
    changePwd() {
      this.passwordVisible = true;
    },
    /**修改密码-保存成功后跳转登录页 */
    changePassword(flag) {
      auth.goLogin();
    },
    /**退出登录 */
    userLogOut() {
      request({
        url: "/auth/oauth/logout",
        method: "get",
      }).then((res) => {
        if (res.code === "00000") {
          // auth.removeAllSession();
          auth.goLogin();
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
  },
};
</script>


<style  lang="scss" scoped>
.el-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  width: 87%;
  margin: 0 auto;
}
.header {
  background: $primaryColor;
  .right {
    display: flex;
  }
  &.is-white {
    background: #fff;
    .el-header {
      color: #1f2123 !important;
    }
    .secondary-title {
      color: #1f2123;
      opacity: 0.68;
    }
    /deep/.el-dropdown {
      .el-dropdown-link {
        color: #1f2123 !important;
        .svg-icon {
          color: #1f2123 !important;
        }
      }
    }
  }
}
.title {
  font-size: 22px;
  display: flex;
  align-items: center;
  img {
    margin: 7px;
    width: 35px;
    height: auto;
    max-height: 56px;
  }
}
.userInfo {
  /deep/.el-dropdown {
    .el-dropdown-link {
      color: #fff;
      cursor: pointer;
      .svg-icon {
        color: #fff;
        font-size: 9px;
        margin-left: 3px;
        vertical-align: 0;
      }
    }
  }
}
.station-info {
  font-size: 14px;
  padding: 16px 15px;
  margin: 10px;
  border-radius: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f4f4f5;
  justify-content: space-between;
  .org {
    width: 300px;
    text-align: left;
  }
  &.actived {
    background-color: #f6e3ce;
  }
}
:deep(.station-dialog) {
  .el-dialog__body {
    padding: 20px 50px;
  }
}
.secondary-title {
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
  opacity: 0.68;
  margin-left: 16px;
}
</style>
<style lang="scss">
.navbar-user-dropdown{
  width: 160px;
  padding: 8px !important;
  .popper__arrow{
    display: none;
  }
  .el-dropdown-menu__item{
    border-radius: 4px;
    &:hover{
      background: $primaryColor !important;
      color: #fff !important;
    }
  }
}
</style>
